import React from 'react';

import clsx from 'clsx';

import styles from './InfoIcon.module.scss';

export interface AttentionIconProps {
  iconClassName?: string;
}
const AttentionIcon = ({ iconClassName }: AttentionIconProps) => {
  return <div className={clsx(styles.icon, iconClassName)}>!</div>;
};

export default AttentionIcon;
